import { reactive, computed, onMounted, onUnmounted } from "vue";

export function useContentFilter({ navigationSectionRef, resetCursor, resetMagnifier, resetScreenRuler, resizeModule = () => {} }) {
    const state = reactive({
        contentsFilter: [
            { name: "Titre",      icon: "fluent:text-header-1-24-regular" },
            { name: "Navigation", icon: "fluent:bookmark-32-regular" },
            { name: "Liens",      icon: "fluent:link-32-regular" },
            { name: "Image",      icon: "fluent:image-multiple-32-regular" },
            { name: "Formulaire", icon: "fluent:content-view-32-regular" },
            { name: "Tableau",    icon: "fluent:table-32-regular" },
        ],
        filteredContent: { title: null, content: [] },
        isShowModal: false,
        isNavigationSectionActive: false,
        input: "",
        activeInput: null,
    });

    // Fix: these were referenced in the template but never defined
    const titleStyle = computed(() => ({ fontSize: "1.1rem", fontWeight: "bold" }));
    const btnStyle = computed(() => ({ cursor: "pointer" }));

    function handleFilterContent(type) {
        let queryString = "";
        switch (type) {
            case "Titre":
                queryString =
                    "h1:not(.no-accessibility),h2:not(.no-accessibility),h3:not(.no-accessibility),h4:not(.no-accessibility),h5:not(.no-accessibility),h6:not(.no-accessibility)";
                break;
            case "Image":
                queryString = "img:not(.no-accessibility)";
                break;
            case "Navigation":
                queryString = "nav:not(.no-accessibility)";
                break;
            case "Liens":
                handleGetLinks(type);
                return;
            case "Formulaire":
                queryString = "form:not(.no-accessibility)";
                break;
            case "Tableau":
                queryString = "table:not(.no-accessibility)";
                break;
            default:
                break;
        }
        state.filteredContent.title = type;
        state.filteredContent.content = Array.from(document.querySelectorAll(queryString));
        state.isShowModal = true;
    }

    function handleGetLinks(type) {
        const navLinks = Array.from(document.querySelectorAll("nav a:not(.no-accessibility)"));
        const allLinks = Array.from(document.querySelectorAll("a:not(.no-accessibility)"));
        state.filteredContent.content = allLinks.filter((link) => !navLinks.includes(link));
        state.filteredContent.title = type;
        state.isShowModal = true;
    }

    function handleDisplayModal(modalInfo) {
        state.filteredContent = modalInfo;
        state.isShowModal = true;
    }

    function handleHideModal() {
        state.isShowModal = false;
    }

    function handleClickElement(element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        const savedBorder = element.style.border;
        element.style.border = "2px solid red";
        setTimeout(() => { element.style.border = savedBorder; }, 3000);
        handleHideModal();
    }

    function toggleNavigationSection() {
        state.isNavigationSectionActive = !state.isNavigationSectionActive;
        const el = navigationSectionRef.value;
        if (el) el.style.height = state.isNavigationSectionActive ? "auto" : "0px";
        resizeModule();
    }

    function resetNavigation() {
        resetCursor();
        resetMagnifier();
        resetScreenRuler();
    }

    function onChange(input) {
        state.input = input;
        if (state.activeInput) {
            state.activeInput.value = input;
            state.activeInput.dispatchEvent(new Event("input", { bubbles: true }));
        }
    }

    function onKeyPress(button) {
        console.log("button", button);
    }

    function onInputFocus(event) {
        const target = event.target;
        if (
            target.matches(
                'input:not([type="color"]):not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="submit"]):not([type="button"]):not([type="reset"]):not([type="image"]), textarea, [contenteditable="true"]'
            )
        ) {
            state.activeInput = target;
            state.input = target.value;
        }
    }

    function onInputBlur() {}

    onMounted(() => {
        document.addEventListener("focusin", onInputFocus);
        document.addEventListener("focusout", onInputBlur);
    });

    onUnmounted(() => {
        document.removeEventListener("focusin", onInputFocus);
        document.removeEventListener("focusout", onInputBlur);
    });

    return {
        state,
        titleStyle,
        btnStyle,
        handleFilterContent,
        handleGetLinks,
        handleDisplayModal,
        handleHideModal,
        handleClickElement,
        toggleNavigationSection,
        resetNavigation,
        onChange,
        onKeyPress,
        onInputFocus,
        onInputBlur,
    };
}
